/** @jsxImportSource theme-ui */
import PropTypes from "prop-types";

export const iconValidator = PropTypes.shape({
  value: PropTypes.any.isRequired,
  iconUrl: PropTypes.string.isRequired,
});
